<script setup lang="ts">
import { IllustrationSearch } from '#components'

withDefaults(defineProps<{
  searchTerm?: string
  withIllustration?: boolean
  suggestion?: string | null
}>(), {
  withIllustration: true,
})

defineEmits<{
  select: [query: string]
}>()
</script>

<template>
  <div class="flex flex-col items-start" :class="withIllustration ? 'gap-xl' : 'gap-m'">
    <p v-if="suggestion" class="flex font-bold text-small">
      Mente du å skrive&nbsp;
      <button type="button" class="hover:underline font-medium italic text-blurple-300 transition-colors" :aria-label="`Søk etter ${suggestion} i stedet`" @mousedown.prevent @click="$emit('select', suggestion)">
        {{ suggestion }}
      </button>
      ?
    </p>
    <p v-if="searchTerm" class="flex font-bold">
      Beklager vi fant ingen treff på "{{ searchTerm }}".
    </p>
    <div class="flex flex-col gap-xs items-stretch">
      <span>Søketips:</span>
      <ul class="list-disc pl-s" aria-label="Søketips">
        <li v-for="tip in SEARCH_TIPS" :key="tip" class="text-small">
          {{ tip }}
        </li>
      </ul>
    </div>
    <IllustrationSearch v-if="withIllustration" class="h-full hidden md:block min-w-[450px] w-[450px]" />
  </div>
</template>
